import { forwardRef, memo, useEffect, useRef } from 'react';
import { Input, InputProps, InputRef } from 'antd';

const CustomInput = ({ autoFoucs, ...props }: InputProps & { autoFoucs?: boolean }, ref: any) => {
    const InputContext = useRef<InputRef | null>(null);

    useEffect(() => {
        autoFoucs && InputContext.current?.focus();
    }, []);

    return <Input {...props} ref={InputContext} />;
};

export default memo(forwardRef(CustomInput));
